var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZigzag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 418,
    height: 42,
    viewBox: "0 0 418 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M203.371 0.916C177.358 -1.162 126.685 2.879 78.641 10.862L67.3 12.749C35.421 18.062 18.2 21.766 6.004 25.934C1.244 27.561 0.828005 27.778 0.874005 28.61C0.944005 29.824 1.702 29.731 10.469 27.434C19.541 25.057 27.619 23.514 49.715 19.938C123.565 7.986 157.869 4.492 195.942 5.046C203.403 5.154 215.192 6.742 215.112 7.628C215.005 8.811 207.238 11.938 189.362 17.994C167.37 25.444 153.932 30.528 152.661 31.878C150.488 34.186 152.459 36.285 157.103 36.612C159.757 36.799 160.366 36.769 172.696 35.832C208.097 33.146 230.64 32.344 261.061 32.689C307.388 33.215 336.782 34.919 391.849 40.273C411.636 42.197 412.663 42.253 416.406 41.605L416.472 41.594C417.673 41.391 418.002 39.769 416.871 39.259C413.96 37.949 411.978 37.655 394.823 35.998C337.314 30.442 306.952 28.638 262.764 28.156C239.525 27.902 229.147 28.04 212.137 28.83C200.508 29.37 169.766 31.324 165.441 31.797C163.082 32.056 173.574 28.172 191.945 21.987C215.184 14.162 219.879 11.838 220.249 7.982C220.666 3.634 216.72 1.982 203.371 0.916Z",
    fill: "#2563EB",
    fillOpacity: 0.36
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZigzag);
export default __webpack_public_path__ + "static/media/zigzag.f55e710a083df578e16363e22b350c8a.svg";
export { ForwardRef as ReactComponent };